import * as React from 'react';
import Link from 'next/link';
import { generateWhatsappUrl } from '@/utils';
import { SUPPORT_WHATSAPP } from '@/utils/constants';
import { Button } from '@mui/material';

// interface IMovideskBtn {
//   style: {
//     visibility: string
//   }
// }

// declare function movideskChatWidgetChangeWindowState(input: string):void

export default function SupportButton() {
  const handleClickButtonSupport = () => {
    // const btnMovidesk = document.querySelector('.md-chat-widget-wrapper') as IMovideskBtn | null
    // const classes = document.querySelector('.md-chat-widget-container')?.classList as DOMTokenList | null
    // if (classes?.contains('minimized')) {
    //   movideskChatWidgetChangeWindowState('maximized')
    //   if (btnMovidesk) {
    //     btnMovidesk.style.visibility = "visible"
    //   }
    // } else {
    //   movideskChatWidgetChangeWindowState('minimized')
    //   if (btnMovidesk) {
    //     btnMovidesk.style.visibility = "hidden"
    //   }
    // }
  };

  return (
    <>
      <Link
        href={generateWhatsappUrl(
          SUPPORT_WHATSAPP,
          'Olá, preciso de ajuda para utilizar o Obra Play'
        )}
        passHref
      >
        <a target="_blank" rel="noreferrer">
          <Button
            sx={{
              width: '100%',
              p: 1,
              color: '#000000',
              textTransform: 'none',
              fontWeight: '400',
            }}
            onClick={handleClickButtonSupport}
          >
            Fale com o suporte
          </Button>
        </a>
      </Link>
    </>
  );
}
